import emailjs from "emailjs-com";

export const sendConfirmationEmail = (mail, date, time) => {
    const appParts = date.split("-");
    const deAppointment = `${appParts[2]}.${appParts[1]}.${appParts[0]} ${time}`;

    emailjs.init("user_bNU2hZGlDQW8bTBkwOPOS");
    emailjs.send("service_lgmpyt5", "template_qklj6ae", {to: mail, termin : deAppointment});
};
